export const EMOJIS = [
	{ id: 0, emoji: "😊" },
	{ id: 1, emoji: "😉" },
	{ id: 2, emoji: "😀" },
	{ id: 3, emoji: "😁" },
	{ id: 4, emoji: "😂" },
	{ id: 5, emoji: "😜" },
	{ id: 6, emoji: "😈" },
	{ id: 7, emoji: "😇" },
	{ id: 8, emoji: "🙈" },
	{ id: 9, emoji: "😎" },
	{ id: 10, emoji: "🤔" },
	{ id: 11, emoji: "🙄" },
	{ id: 12, emoji: "😘" },
	{ id: 13, emoji: "😍" },
	{ id: 14, emoji: "❤️" },
	{ id: 15, emoji: "👍" },
	{ id: 16, emoji: "👎" },
	{ id: 17, emoji: "🖕" },
	{ id: 18, emoji: "💪" },
	{ id: 19, emoji: "😢" },
	{ id: 20, emoji: "😬" },
	{ id: 21, emoji: "😲" },
	{ id: 22, emoji: "😱" },
	{ id: 23, emoji: "🙁" },
	{ id: 24, emoji: "🍷" },
	{ id: 25, emoji: "🥂" },
	{ id: 26, emoji: "🍾" },
	{ id: 27, emoji: "🍑" },
	{ id: 28, emoji: "💋" },
	{ id: 29, emoji: "🍦" },
	{ id: 30, emoji: "🍌" },
	{ id: 31, emoji: "🍆" },
	{ id: 32, emoji: "🌈" },
	{ id: 33, emoji: "🔥" },
	{ id: 34, emoji: "💦" },
	{ id: 35, emoji: "🌹" },
];
